import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { ProjectActions } from '../actions/project';

const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  userMode: 'user',
  projects: null,
  showModal: false,
  isSubmitting: false,
  product: 'planner',
  meta: {},
});

export const project = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.getProjectMappings.success]: (state, action) => {
    const mappings = action.result.reduce(
      (prev, cur) => prev.set(cur.name, cur.id),
      state.get('meta'),
    );

    return state.set('meta', mappings);
  },

  [projectActions.changeProducts]: (state, action) => {
    return state.set('product', action.product);
  },

  [projectActions.getProject.success]: (state, action) => {
    const currentProject =
      action.result.entities.projects[action.result.result];

    const role = currentProject.role;
    const userMap = {
      1: 'admin',
      2: 'admin',
      3: 'user',
      4: 'reader',
    };

    return state.mergeDeep({
      userMode: userMap[role],
    });
  },
});

export const flatTaskDsmIdSelector = state => {
  return state.project.getIn(['meta', 'Flat Task DSM']);
};

export const ppcGraphIdSelector = state => {
  return state.project.getIn(['meta', 'PPC Graph']);
};

export const rootCauseGraphIdSelector = state => {
  return state.project.getIn(['meta', 'Root Cause Graph']);
};

export const productSelector = state => {
  return state.project.get('product');
}



// WEBPACK FOOTER //
// ./src/reducers/project.js